(function () {
  var phonePattern = /^\+?(?:[\s().-]*\d){7,15}[\s().-]*$/;

  function setOptionalField(input, value) {
    if (!input) return;
    if (value) {
      input.disabled = false;
      input.value = value;
    } else {
      input.disabled = true;
      input.value = '';
    }
  }

  function readVariant() {
    var scope = document.querySelector('.main-product-section') || document;
    var idInput = scope.querySelector('product-form input[name="id"], input.product-variant-id');
    var variantId = idInput ? idInput.value : '';
    var jsonEl = scope.querySelector('script.productJson[data-product-json]');
    if (!jsonEl || !variantId) return null;
    try {
      var product = JSON.parse(jsonEl.textContent);
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(variantId)) return variants[i];
      }
    } catch (error) {
      return null;
    }
    return null;
  }

  function variantDetails(variant) {
    var title = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    var sku = variant && variant.sku ? String(variant.sku) : '';
    return { title: title, sku: sku };
  }

  function init(root) {
    if (!root || root.dataset.askReady === 'true') return;
    var contactForm = root.querySelector('#ContactForm');
    var newsletterForm = root.querySelector('#Ask-newsletter-form');
    var subscribeCheckbox = root.querySelector('#Ask-subscribe-newsletter');
    var emailInput = root.querySelector('#Ask-email');
    var phoneInput = root.querySelector('#Ask-phone');
    var messageInput = root.querySelector('#AskMessage');
    var newsletterEmail = root.querySelector('#Ask-newsletter-email');
    var submitButton = root.querySelector('#Ask-submit-button');
    var formView = root.querySelector('[data-ask-view="form"]');
    var successView = root.querySelector('[data-ask-view="success"]');
    var errorBox = root.querySelector('[data-ask-error]');
    var newsletterNote = root.querySelector('[data-ask-newsletter-note]');
    if (!contactForm || !newsletterForm || !newsletterEmail || !subscribeCheckbox || !emailInput || !messageInput || !submitButton || !formView || !successView) return;

    root.dataset.askReady = 'true';
    var addon = root.closest('product-addons');
    var lockView = false;
    var submitting = false;
    var nativeSubmitForm = null;
    var storageKey = 'askQuestionSubmission:' + window.location.pathname;
    var newsletterFailureMessage = newsletterNote ? newsletterNote.textContent : '';

    function clearPending() {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (error) {}
    }

    function readPending() {
      try {
        var state = JSON.parse(window.sessionStorage.getItem(storageKey));
        if (!state) return null;
        if (state.version !== 1 || !state.id || !state.email || !state.details ||
            ['contact', 'newsletter'].indexOf(state.phase) === -1 ||
            !Number.isFinite(state.createdAt) || Date.now() - state.createdAt < 0 ||
            Date.now() - state.createdAt > 15 * 60 * 1000) {
          clearPending();
          return null;
        }
        return state;
      } catch (error) {
        clearPending();
        return null;
      }
    }

    function savePending(state) {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(state));
        return true;
      } catch (error) {
        return false;
      }
    }

    function returnUrl(result) {
      var url = new URL(window.location.href);
      ['ask_question', 'contact_posted', 'customer_posted'].forEach(function (key) {
        url.searchParams.delete(key);
      });
      if (result) url.searchParams.set('ask_question', result);
      url.hash = result ? 'ContactForm' : '';
      return url.pathname + url.search + url.hash;
    }

    function clearReturnResult() {
      if (!new URL(window.location.href).searchParams.has('ask_question')) return;
      window.history.replaceState(window.history.state, '', returnUrl(''));
    }

    function setReturnTo(form, result) {
      var input = form.querySelector('[name="return_to"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.appendChild(input);
      }
      input.value = returnUrl(result);
    }

    function submitProtected(form, onFailure) {
      var waiting = true;
      var timer = window.setTimeout(fail, 20000);
      function fail() {
        if (!waiting) return;
        waiting = false;
        window.clearTimeout(timer);
        onFailure();
      }
      function ready() {
        if (!waiting) return;
        waiting = false;
        window.clearTimeout(timer);
        window.setTimeout(function () {
          try {
            if (!form.reportValidity()) {
              onFailure();
              return;
            }
            nativeSubmitForm = form;
            form.requestSubmit();
          } catch (error) {
            onFailure();
          } finally {
            nativeSubmitForm = null;
          }
        }, 0);
      }
      try {
        if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
          window.Shopify.captcha.protect(form, ready);
        } else {
          ready();
        }
      } catch (error) {
        fail();
      }
    }

    function setLoading(isLoading) {
      submitButton.classList.toggle('loading', isLoading);
      submitButton.disabled = isLoading;
      submitButton.toggleAttribute('aria-disabled', isLoading);
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message || '';
      errorBox.hidden = !errorBox.textContent;
    }

    function showForm() {
      formView.hidden = false;
      successView.hidden = true;
      if (newsletterNote) newsletterNote.hidden = true;
      showError('');
      setLoading(false);
    }

    function writeSuccessMeta(details) {
      var variantRow = root.querySelector('[data-ask-success-variant]');
      var skuRow = root.querySelector('[data-ask-success-sku]');
      if (variantRow) {
        variantRow.hidden = !details.title;
        var variantValue = variantRow.querySelector('[data-ask-value]');
        if (variantValue) variantValue.textContent = details.title;
      }
      if (skuRow) {
        skuRow.hidden = !details.sku;
        var skuValue = skuRow.querySelector('[data-ask-value]');
        if (skuValue) skuValue.textContent = details.sku;
      }
    }

    function showSuccess(newsletterFailed, details) {
      writeSuccessMeta(details);
      formView.hidden = true;
      successView.hidden = false;
      if (newsletterNote) {
        newsletterNote.textContent = newsletterFailed === 'pending' ? root.dataset.newsletterPending : newsletterFailureMessage;
        newsletterNote.hidden = !newsletterFailed;
      }
      setLoading(false);
      var modalContent = root.closest('.tingle-modal-box__content');
      if (modalContent) modalContent.scrollTop = 0;
    }

    function fieldValue(selector) {
      var input = root.querySelector(selector);
      if (!input || input.disabled) return '';
      return input.value || '';
    }

    function syncProductFields() {
      var variant = readVariant();
      if (!variant) {
        return {
          title: fieldValue('[data-ask-field="variant"]'),
          sku: fieldValue('[data-ask-field="sku"]')
        };
      }
      var details = variantDetails(variant);
      setOptionalField(root.querySelector('[data-ask-field="variant"]'), details.title);
      setOptionalField(root.querySelector('[data-ask-field="sku"]'), details.sku);
      return details;
    }

    function composeBody(details) {
      var lines = [messageInput.value.replace(/\s+$/, ''), ''];
      lines.push('Product: ' + fieldValue('[name="contact[Product]"]'));
      if (details.title) lines.push('Variant: ' + details.title);
      if (details.sku) lines.push('SKU: ' + details.sku);
      var productUrl = fieldValue('[name="contact[Product URL]"]');
      if (productUrl) lines.push('Product URL: ' + productUrl);
      return lines.join('\n');
    }

    function openResult(newsletterFailed, details) {
      var open = function () {
        lockView = true;
        showSuccess(newsletterFailed, details);
        if (addon) addon.click();
        lockView = false;
      };
      if (!addon || customElements.get('product-addons')) open();
      else customElements.whenDefined('product-addons').then(open);
    }

    function finishNewsletter(failed, state) {
      clearPending();
      clearReturnResult();
      submitting = false;
      openResult(failed, state.details);
    }

    function submitNewsletter(state) {
      state.phase = 'newsletter';
      if (!savePending(state)) {
        finishNewsletter(true, state);
        return;
      }
      newsletterEmail.value = state.email;
      setReturnTo(newsletterForm, 'newsletter.' + state.id);
      submitting = true;
      openResult('pending', state.details);
      submitProtected(newsletterForm, function () {
        finishNewsletter(true, state);
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        if (!phoneInput.value || phonePattern.test(phoneInput.value)) {
          phoneInput.setCustomValidity('');
        } else {
          phoneInput.setCustomValidity(root.dataset.phoneFormat || '');
        }
      });
    }

    if (addon) {
      addon.addEventListener('click', function (event) {
        if (lockView) return;
        if (root.contains(event.target)) return;
        showForm();
      });
    }

    var closeButton = root.querySelector('[data-ask-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        var modal = root.closest('.tingle-modal');
        var tingleClose = modal && modal.querySelector('.tingle-modal__close');
        if (tingleClose) tingleClose.click();
      });
    }

    contactForm.addEventListener('formdata', function (event) {
      event.formData.set('contact[body]', composeBody(syncProductFields()));
    });

    contactForm.addEventListener('submit', function (event) {
      if (nativeSubmitForm === contactForm) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitting || !contactForm.reportValidity()) return;
      showError('');
      var details = syncProductFields();
      clearPending();
      var result = 'sent';
      if (subscribeCheckbox.checked) {
        var state = {
          version: 1,
          id: window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2),
          createdAt: Date.now(),
          phase: 'contact',
          email: emailInput.value.trim(),
          details: details
        };
        if (!savePending(state)) {
          showError(root.dataset.storageError || root.dataset.submitError || '');
          return;
        }
        result = 'contact.' + state.id;
      }
      setReturnTo(contactForm, result);
      submitting = true;
      setLoading(true);
      submitProtected(contactForm, function () {
        clearPending();
        submitting = false;
        showError(root.dataset.submitError || '');
        setLoading(false);
      });
    }, true);

    var pending = readPending();
    var returnResult = new URL(window.location.href).searchParams.get('ask_question');
    var contactSuccess = contactForm.querySelector('[data-ask-form-status="success"]');
    var contactError = contactForm.querySelector('[data-ask-form-status="error"]');
    var newsletterError = newsletterForm.querySelector('[data-ask-newsletter-status="error"]');
    if (pending && pending.phase === 'newsletter') {
      var newsletterSuccess = newsletterForm.querySelector('[data-ask-newsletter-status="success"]');
      finishNewsletter(Boolean(newsletterError) || !(returnResult === 'newsletter.' + pending.id || (!returnResult && newsletterSuccess)), pending);
    } else if (pending && !contactError && (returnResult === 'contact.' + pending.id || (!returnResult && contactSuccess))) {
      clearReturnResult();
      submitNewsletter(pending);
    } else if (returnResult === 'sent' || (!pending && !returnResult && contactSuccess)) {
      clearReturnResult();
      openResult(false, variantDetails(readVariant()));
    } else if (!pending && returnResult) {
      clearReturnResult();
      openResult(returnResult.indexOf('contact.') === 0, variantDetails(readVariant()));
    } else if (contactError) {
      if (pending) subscribeCheckbox.checked = true;
      clearPending();
      clearReturnResult();
      if (addon) addon.click();
    }
  }

  function boot() {
    document.querySelectorAll('[data-ask-question]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

